import { Component, Inject, OnInit } from '@angular/core';
import { FiltroProductosService } from '../../../services/filtro-productos.service';
import { ClienteVM } from './../../../../../_entities/clientes/ClienteVM';
import { UsuarioVM } from './../../../../../_entities/usuarios/UsuarioVM';
import { FiltroProductos } from './../../../../../_entities/productos/filtro-productos';
import { MapaService } from '../../../services/mapa.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { GPS, GSM } from './../../../../../_entities/estados';

@Component({
	selector: 'kt-filtro-productos',
	templateUrl: './filtro-productos.component.html',
	styleUrls: ['./filtro-productos.component.scss']
})
export class FiltroProductosComponent implements OnInit {
	public clientes: ClienteVM[];
	public usuarios: UsuarioVM[];
	public usuariosSeleccionados = [];
	public activosDisponibles = [];
	public lectorasDisponibles = [];
	public medidoresDisponibles = [];
	public micromedidoresDisponibles = [];
	public telefonosDisponibles = [];
	public vehiculosDisponibles = [];
	public datosReporte = [];
	public productosGeneral = [];
	public isDisabled = true;
	public productosDisponibles = false;
	public idCliente;

	public currentFilter: any;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;

	constructor(private filtroProductosService: FiltroProductosService,
		private mapaService: MapaService,
		private toastService: ToastrService,
		private dialogRef: MatDialogRef<FiltroProductosComponent>) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.obtenerClientes();
	}

	obtenerClientes() {
		this.filtroProductosService.obtenerClientes().subscribe(
			(clientes: ClienteVM[]) => {
				this.clientes = clientes;
			}, (error) => {
				console.log(error);

			}
		);
	}

	obtenerUsuariosCliente() {
		this.filtroProductosService.obtenerUsuariosIdCliente(this.idCliente).subscribe(
			(usuarios: UsuarioVM[]) => {
				this.usuarios = usuarios;
				usuarios.forEach(usuario => {
					this.datosReporte.push({
						'Nombre': usuario.nombreCompleto,
					});
				});

				if (this.datosReporte.length > 0) {
					this.isDisabled = false;
				}
			}, (error) => {
				console.log(error);

			}
		);
	}

	changeValue(checked, usuario) {
		if (checked) {
			this.usuariosSeleccionados.push(usuario.id);
		} else {
			this.usuariosSeleccionados.splice(this.clientes.indexOf(usuario.id), 1);
		}
	}

	obtenerProductosUsuario() {
		this.mapaService.usuariosFlitro = this.usuariosSeleccionados;
		this.reiniciarArreglos();
		this.mapaService.registroVehiculos = [];
		const promise = new Promise((resolve, reject) => {
			this.usuariosSeleccionados.forEach((usuario, index, array) => {
				this.filtroProductosService.obtenerProductosIdUsuario(usuario).pipe(
					finalize(
						() => {
							if (index === array.length - 1) {
								resolve(null);
							}
						}
					)
				).subscribe(
					(productos: any[]) => {

						if (productos.length > 0) {
							this.mapaService.limpiarMapa();
							this.mapaService.containerEtiquetas = false;
							this.productosDisponibles = true;
							this.mapaService.registroVehiculos = productos;
							//this.mapaService.limpiarDispositivos();
							productos.forEach(producto => {
								switch (producto.idProducto) {
									case 2:
										this.vehiculosDisponibles.push(producto);
										break;
									case 3:
										if (producto.bateria == null || producto.bateria == '') {
											producto.bateria = 'Sin Batería'
										} else {
											producto.bateria = producto.bateria + '%'
										}
										const alertaGSMA = GSM.find(gsm => producto.gsm == gsm.id);
										producto.gsm = alertaGSMA.nombre;
										try {
											const alertaGPS = GPS.find(gps => producto.gps == gps.id);
											producto.gps = alertaGPS.nombre;
										} catch (error) {
											producto.gps = 'Mala';
										}
										this.activosDisponibles.push(producto);
										break;
									case 4:
										if (producto.bateria == null || producto.bateria == '') {
											producto.bateria = 'Sin Batería'
										} else {
											producto.bateria = producto.bateria + '%'
										}
										const alertaGSMT = GSM.find(gsm => producto.gsm == gsm.id);
										producto.gsm = alertaGSMT.nombre;
										try {
											const alertaGPS = GPS.find(gps => producto.gps == gps.id);
											producto.gps = alertaGPS.nombre;
										} catch (error) {
											producto.gps = 'Mala';
										}
										switch (producto.estatus) {
											case 0:
												producto.estatus = 'Inactivo';
												break;
											case 1:
												producto.estatus = 'Activo';
												break;
											default:
												producto.estatus = 'Sin datos';

												break;
										}
										this.telefonosDisponibles.push(producto);
										break;
									case 5:
										this.medidoresDisponibles.push(producto);
										break;
									case 6:
										this.micromedidoresDisponibles.push(producto);
										break;
									case 7:
										this.lectorasDisponibles.push(producto);
										break;
									default:
										break;
								}

							});
						} else {
							this.toastService.warning('Sin productos disponibles', 'Información');
						}
					}, (error) => {
						console.log(error);
					}
				)
			});
		});

		promise.then(() => {
			if (this.productosDisponibles) {
				this.mapaService.sonProductosFiltrados = true;
				this.mapaService.clusterActivo = false;
				this.mapaService.pintarMarcadoresPuntoInteres();
				this.pintarProductos();
				this.mapaService.mostrarParaSiempre();
				this.mapaService.regresarMapa();
			}
			this.dialogRef.close();
		});
	}

	pintarProductos() {
		if (this.activosDisponibles.length > 0) {
			console.log(this.activosDisponibles);

			this.mapaService.activosDisponibles = this.activosDisponibles;
			this.mapaService.pintarClusterActivos();
			this.mapaService.pintarMarcadoresActivos();
			this.mapaService.ocultarClusterActivo();
		}

		if (this.lectorasDisponibles.length > 0) {
			this.mapaService.lectorasDisponibles = this.lectorasDisponibles;
			this.mapaService.pintarClusterLectoras();
			this.mapaService.ocultarClusterLectoras();
			this.mapaService.pintarMarcadoresLectoras();
		}

		if (this.medidoresDisponibles.length > 0) {
			this.mapaService.medidoresDisponibles = this.medidoresDisponibles;
			this.mapaService.pintarClusterMedidores();
			this.mapaService.ocultarClusterMedidores();
			this.mapaService.pintarMarcadoresMedidores();
		}

		if (this.micromedidoresDisponibles.length > 0) {
			this.mapaService.micromedidoresDisponibles = this.micromedidoresDisponibles;
			this.mapaService.pintarClusterMicromedidores();
			this.mapaService.ocultarClusterMicromedidores();
			this.mapaService.pintarMarcadoresMicromedidores();
		}

		if (this.telefonosDisponibles.length > 0) {
			this.mapaService.telefonosDisponibles = this.telefonosDisponibles;
			this.mapaService.pintarClusterTelefonos();
			this.mapaService.ocultarClusterTelefonos();
			this.mapaService.pintarMarcadoresTelefonos();
		}

		if (this.vehiculosDisponibles.length > 0) {
			this.mapaService.vehiculosDisponibles = this.vehiculosDisponibles;
			this.mapaService.pintarClusterVehiculos();
			this.mapaService.ocultarClusterVehiculos();
			this.mapaService.pintarMarcadoresVehiculos();
		}
	}

	reiniciarArreglos() {
		this.activosDisponibles = [];
		this.lectorasDisponibles = [];
		this.medidoresDisponibles = [];
		this.micromedidoresDisponibles = [];
		this.telefonosDisponibles = [];
		this.vehiculosDisponibles = [];
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
